module.exports = __webpack_public_path__ + "4289050503a1526fd5530ca6808f7a24.png";